import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { StickyTrapRequest } from '../../models/sticky-trap';
import { StickyTrapService } from '../../services/sticky-trap.service';

@Component({
  selector: 'app-add-sticky-trap',
  templateUrl: './add-sticky-trap.component.html',
  styleUrls: ['./add-sticky-trap.component.scss'],
})
export class AddStickyTrapComponent implements OnInit {
  @Input() header: string;
  @Input() date;
  @Input() deviceId;
  @Input() stickyId: number = 0;
  @Input() id: number;
  constructor(
    private modalService: ModalService,
    private sticyTrapService: StickyTrapService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private translateService: TranslateService) { }

  dismiss() {
    this.modalService.dismissByModalId(this.id, null);
  }

  ngOnInit() {
   }

  onDateChange(ev) {
    this.date = ev;
  }

  save() {
    let payload: StickyTrapRequest = {
      ChangeDate: this.date,
      DeviceId: this.deviceId,
      Id: this.stickyId
    }
    this.loadingService.showLoading()
    this.sticyTrapService.saveSticky(payload).subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        this.toastService.PresentBasicToast({ message: this.translateService.instant("sticky-trap.save-success"), duration: 3500, type: Message_Type.SUCCESS });
        this.modalService.dismissByModalId(this.id, true, "success");
      } else {
        if (e.ValidationErrors && e.ValidationErrors.length > 0) {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.ValidationErrors[0]), duration: 3500, type: Message_Type.WARNING });
        } else if (e.Message) {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.Message), duration: 3500, type: Message_Type.DANGER });
        }
      }
    })
  }

}
